/**
 * @generated SignedSource<<4b322cc71a65a03f07bc4ad65c02b514>>
 * @relayHash bf4c26c437f0d24734ab6a45b91a89f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 19c8a838839c59651162971c4a2d75f411753ed614f352d6ea25345edb61469b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type srcFieldConfigurationSchemesQuery$variables = {
  cloudId: string;
};
export type srcFieldConfigurationSchemesQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_adminPagesFieldConfigurationSchemes_FieldConfigurationSchemesPage">;
};
export type srcFieldConfigurationSchemesQuery = {
  response: srcFieldConfigurationSchemesQuery$data;
  variables: srcFieldConfigurationSchemesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "srcFieldConfigurationSchemesQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ui_adminPagesFieldConfigurationSchemes_FieldConfigurationSchemesPage"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "srcFieldConfigurationSchemesQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraFieldConfigSchemesConnection",
        "kind": "LinkedField",
        "name": "jira_fieldSchemes",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraFieldConfigSchemesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraFieldConfigScheme",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "fieldsCount"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "projectsCount"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v1/*: any*/),
        "filters": [
          "cloudId"
        ],
        "handle": "connection",
        "key": "fieldConfigurationSchemesTable_adminPagesFieldConfigurationSchemes_jira_fieldSchemes",
        "kind": "LinkedHandle",
        "name": "jira_fieldSchemes"
      }
    ]
  },
  "params": {
    "id": "19c8a838839c59651162971c4a2d75f411753ed614f352d6ea25345edb61469b",
    "metadata": {},
    "name": "srcFieldConfigurationSchemesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e9bb8423c73d22766b9d8cf4f4f663ce";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
